export default "__VITE_ASSET__CPN9N_95__"